import React, { useId } from 'react';
import { useTheme } from '../hooks/useTheme';
import AnalyticsManager from '../utils/AnalyticsManager';
import './ThemeToggle.css';

interface ThemeToggleProps {
  variant?: 'footer' | 'toolbar';
  className?: string;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ variant = 'footer', className = '' }) => {
  const { isDark, toggleTheme } = useTheme();
  const maskId = `theme-toggle-mask-${useId()}`;

  const size = variant === 'toolbar' ? 22 : 18;

  return (
    <button
      className={`theme-toggle ${isDark ? 'theme-toggle--dark' : 'theme-toggle--light'} ${className}`}
      onClick={() => {
        const analytics = AnalyticsManager.getInstance();
        analytics.trackEvent('theme_toggle', {
          new_theme: isDark ? 'light' : 'dark',
          event_category: 'preferences',
        });
        toggleTheme();
      }}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      type="button"
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <mask id={maskId}>
            <rect x="0" y="0" width="24" height="24" fill="white" />
            <circle className="theme-toggle__moon-mask" cx="15" cy="7" r="6" fill="black" />
          </mask>
        </defs>

        {/* Sun rays */}
        <g className="theme-toggle__rays" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <line className="theme-toggle__ray" x1="12" y1="1" x2="12" y2="3" />
          <line className="theme-toggle__ray" x1="19.8" y1="4.2" x2="18.4" y2="5.6" />
          <line className="theme-toggle__ray" x1="23" y1="12" x2="21" y2="12" />
          <line className="theme-toggle__ray" x1="19.8" y1="19.8" x2="18.4" y2="18.4" />
          <line className="theme-toggle__ray" x1="12" y1="23" x2="12" y2="21" />
          <line className="theme-toggle__ray" x1="4.2" y1="19.8" x2="5.6" y2="18.4" />
          <line className="theme-toggle__ray" x1="1" y1="12" x2="3" y2="12" />
          <line className="theme-toggle__ray" x1="4.2" y1="4.2" x2="5.6" y2="5.6" />
        </g>

        {/* Sun/Moon body */}
        <circle
          className="theme-toggle__body"
          cx="12"
          cy="12"
          r="5.5"
          fill="currentColor"
          mask={`url(#${maskId})`}
        />
      </svg>
    </button>
  );
};

export default ThemeToggle;
